import { httpRequest } from "../../../utils/HttpRequest";
import { IPurchaseApprovalSearch, IPurchaseApprovalDetail, IPurchaseApprovalFields, Detailed, IPurchaseApprovalList, IPurchaseApprovalStatistics } from "./purchaseApprovalType"
class PurchaseApprovalService {
    async page(searchVo: IPurchaseApprovalSearch) {
        const apiUrl = "/zzw-vrm/purchaseApproval/findPage";
        return await httpRequest.post<IPurchaseApprovalList>(apiUrl, searchVo);
    }
    async total(searchVo: IPurchaseApprovalSearch) {
        const apiUrl = "/zzw-vrm/purchase/approval/total";
        return await httpRequest.post<IPurchaseApprovalStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/purchaseApproval/findById/${id}`;
        return await httpRequest.get<IPurchaseApprovalDetail>(apiUrl);
    }
    async oneLog(id: string) {
        const apiUrl = `/zzw-vrm/purchaseApproval/findTransferRecord/${id}`;
        return await httpRequest.get<IPurchaseApprovalDetail>(apiUrl);
    }
    async returnApproval(id: string) {
        const apiUrl = `/zzw-vrm/purchaseApproval/againEnquiry/${id}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async insert(insertVo: IPurchaseApprovalFields) {
        const apiUrl = "/zzw-vrm/purchaseApproval/insert";
        return await httpRequest.post<IPurchaseApprovalDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchaseApprovalFields) {
        const apiUrl = "/zzw-vrm/purchaseApproval/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/purchase/approval/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IPurchaseApprovalSearch) {
        const apiUrl = "/zzw-vrm/purchaseApproval/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    //提交
    async submit(id: string) {
        const apiUrl = `/zzw-vrm/purchaseApproval/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //转采购订单
    async onTranfer(id: string) {
        const apiUrl = `/zzw-vrm/purchaseApproval/transferPlan/${id}`;
        return await httpRequest.get<any>(apiUrl);
    }
    //转采购单
    async demo(approvalCode: string) {
        const apiUrl = `/zzw-vrm/purchase/approval/transfer/${approvalCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async transfer(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseApproval/approval";
        return await httpRequest.post<IPurchaseApprovalStatistics>(apiUrl, searchVo);
    }
    async tranPlan(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseApproval/batchTransferPlan";
        return await httpRequest.post<IPurchaseApprovalStatistics>(apiUrl, searchVo);
    }
    // //详情导入
    // async import(){
    //     const apiUrl = "/zzw-vrm/purchase/approval/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/zzw-vrm/purchaseApproval/writeExcelTemplate";
        return await httpRequest.postFile<boolean>(apiUrl);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/purchase/approval/print/${id}`;
        return await httpRequest.get(apiUrl);
    }

    async findDetailByCodes(codes: string[]) {
        const apiUrl = "/zzw-vrm/purchaseApproval/findDetailByCodes";
        return await httpRequest.post<IPurchaseApprovalDetail>(apiUrl, codes);
    }
}

export const purchaseApprovalService = new PurchaseApprovalService();